import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from "vuex-persist"
import jwt_decode from "jwt-decode"

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    refresh_token: null,
    access_token: null,
    logged_in: false,
    redirect_to: null
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    setToken(state, payload) {
      state.access_token = payload
      state.logged_in = true
    },
    setRefreshToken(state, payload) {
      state.refresh_token = payload
    },
    dropToken(state, clear_redirect_to) {
      localStorage.clear()
      state.access_token = null
      state.logged_in = false
      state.redirect_to = clear_redirect_to ? null : state.redirect_to
    },
    setRedirectTo(state, payload){
      state.redirect_to = payload
    }
  },
  getters: {
    isLoggedIn: (state) => {
      return state.logged_in
    },
    isAnalyst: (state) => {
      return jwt_decode(state.access_token).is_analyst;
    },
    isSuperadmin: (state) => {
      return jwt_decode(state.access_token).is_superadmin;
    },
    refreshToken: (state) => {
      return state.refresh_token
    },
    authHeader: (state) => {
      if (state.access_token) {
        return { Authorization: 'Bearer ' + state.access_token }
      }
      else {
        return {}
      }
    },
    accessToken: (state) => {
      return state.access_token
    },
    redirectTo: (state) => {
      return state.redirect_to 
    }
  }
})